module.exports = __webpack_public_path__ + "img/waiting.4444c370.png";